import React, { FC, useCallback } from 'react';
import { useField } from 'formik';
import SearchInput, { SearchInputProps } from '@minecraft.search-input';

type Props = {
  name: string;
  testId?: string;
} & Omit<SearchInputProps, 'onChange' | 'value'>;

const FormikSearchInput: FC<Props> = ({ name, ...restProps }) => {
  const [field, , helpers] = useField(name);

  const handleClear = useCallback(() => {
    helpers.setValue('');
  }, [helpers]);

  return (
    <SearchInput name={field.name} value={field.value} onChange={field.onChange} onClear={handleClear} {...restProps} />
  );
};

export default FormikSearchInput;
